module.exports = __webpack_public_path__ + "static/media/mvp-bgm.bbfa01d9.mp3";